import type { LalSegmentApi } from '@openx/types/segments.ts';

export const isLalSegmentDeleted = (lalSegment: LalSegmentApi) => !!lalSegment.is_archived;
